module.exports = __webpack_public_path__ + "img/h2h-character-sheet.ea111f5f.jpg";